import { createApp } from 'vue'
import App           from "./App.vue";
import store         from "./store";

export default class Profile
{


    static launch ()
    {

        console.log("Profile 2023-06-08");

        let el = document.querySelector( "#profile" );

        const vueProfile = createApp( App );

        vueProfile
            .provide( 'copydeck', __copydeck__.profile )
            .provide( 'profileForm', __profile__ )
            .provide( 'themes', __themes__ )
            .provide( 'user', __user__ )
            .provide( 'avatars', __avatars__ )
            .provide( 'availableAvatars', __availableAvatars__ )
            .provide( 'avatarFrames', __avatarFrames__ )
            .provide( 'availableFrames', __availableFrames__ )
            .provide( 'defaultAvatarId', __defaultAvatarId__ )
            .use( store )
            .mount( el );
    }


}




